<template>

  <v-dialog
    v-model="show"
    persistent
    width="1280"
    >
    <v-card style="background: #f0f0f0; padding: 6px;">
    <v-toolbar class="ma-1"  dense  elevation="0" rounded>
            <v-icon left >mdi-file-document-outline</v-icon><span class="va-underline">{{state=='new'?'New':'Modify'}} Purchase </span>
            <v-spacer/>
           
              <v-btn tile small @click="emitToParent('close')">
                <v-icon small left>mdi-printer</v-icon>
                <span>Print</span>
              </v-btn>
                <v-btn tile small @click="emitToParent('close')">
                <v-icon small left>mdi-close</v-icon>
                <span>Close</span>
              </v-btn>
              <v-btn tile small @click="validate()" color="primary">
                <v-icon small left>mdi-check</v-icon>
                <span>{{state=='new'?'New':'Save'}}</span>
              </v-btn>
          </v-toolbar>
         <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >   
            <v-row no-gutters>
              <v-col cols="12">
                <v-card class="ma-1" tile elevation="0">
                  <v-card-text>
                      <table class="va-table va-align-top">
                            <tr>
                              <td>
                                  <p class="text-h6 font-weight-bold">No.: {{ order.id }}</p> 
                              </td>
                              <td class="text-right">
                                <p class="text-h6 font-weight-bold">Status: {{ order.status }}</p>
                              </td>
                            </tr>
                            <tr>
                              <td width="50%">
                                <v-select 
                                 :rules="FieldRules('Vendor required')"
                                  v-model="order.vendor"
                                  :disabled="!ALLOWED"
                                  :items="vendors"
                                  dense 
                                  item-text="name"
                                return-object
                                  label="Vendor">
                                  <template v-slot:append-item>
                                        <div class="pl-4">
                                            <a class="md-font" @click="vendorForm=true"><v-icon small left>mdi-plus</v-icon>New Vendor</a>
                                        </div>
                                      </template>
                                  </v-select>
                          
                              </td>
                              <td>
                                <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="order.po_date"
                                       :disabled="!ALLOWED"
                                       :rules="FieldRules('Date is required.')"
                                      label="Date"
                                    dense
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="order.po_date"
                                    no-title
                                    scrollable
                                    @input="menu = false"
                                  >
                                
                                  </v-date-picker>
                                </v-menu>
                              </td>
                            </tr>
                      </table>

                      <table class="va-table mt-4">
                            <tr>
                              <th>SHIPPING</th>
                              <th></th>
                              <th>PAYMENT TERMS</th>
                            </tr>
                            <tr>
                              <td>
                                  <v-text-field 
                                    v-model="terms.shipping_term"
                                  class="mt-4" 
                                   :disabled="!ALLOWED"
                                  dense label="Shipping Terms"/>
                              </td>
                              <td>
                                <v-text-field 
                                    v-model="terms.shipping_via"
                                  class="mt-4" 
                                   :disabled="!ALLOWED"
                                  dense label="Shipping Via"/>
                              </td>
                              <td>
                                  <v-combobox 
                                    v-model="terms.payment_term"
                                  class="mt-4"
                                   :disabled="!ALLOWED"
                                  :items="PAYMENT_TERMS"
                                  dense 
                                  label="Payment Terms"/>
                              </td>
                            </tr>
                      </table>
                  </v-card-text>
                </v-card>     
              </v-col>
            </v-row>     
    </v-form>
    <v-row no-gutters>
         
        <v-col cols="12">
          <v-card class="ma-1" tile elevation="0">
         
              <v-card-text>
                <table class="va-table va-table-border-bot">
                  <tr>
                    <td width="50"></td>
                    <td>ITEM</td>
                    <td>DESCRIPTION</td>
                    <td class="text-center" width="100">QTY</td>
                    <td class="text-center" width="130">UNIT PRICE</td>
                    <td class="text-right">AMOUNT</td>
                  </tr>
                  <tr v-for="(item,index) in po_items" :key="index">
                    <td> 
                        <v-icon  v-if="ALLOWED" left color="warning" small @click="removeItem(index)">mdi-close</v-icon>
                        {{ index+1 }}.
                    </td>
                    <td class="pa-2">
                     
                      {{item.name}}
                    </td>
                    <td>{{item.description}}</td>
                    <td class="pa-2">

                      <v-text-field 
                            v-model="item.quantity"
                           :disabled="!ALLOWED"
                            dense
                            class="pa-1 input-center"
                            type="number"
                             @change="item.amount = item.unit_price*item.quantity"
                         />
                    </td>
                    <td class="pa-2">
                      <v-text-field 
                            v-model="item.unit_price"
                           :disabled="!ALLOWED"
                            dense
                             class="pa-1 input-center"
                            type="number"
                            @change="item.amount = item.unit_price*item.quantity"
                         />
                    </td>
                    <td class="text-right pa-2">
                     {{$money(item.amount)}}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <div style="width: 280px" class="pt-8">
                      <v-autocomplete 
                          v-model="product"
                          :items="productlist"
                          v-if="ALLOWED" 
                          dense 
                          prepend-icon="mdi-plus"
                          item-text="name"
                         return-object
                        @change="addItem(product)"
                          label="Add product to purchase">
                          <template v-slot:append-item>
                                <div class="pl-4">
                                    <a class="md-font" @click="showform=true"><v-icon small left>mdi-plus</v-icon>New Product</a>
                                </div>
                              </template>
                          </v-autocomplete>
                        </div>
                      </td>
                    
                  </tr>
                 
                  </table>
                  <v-row>
                      <v-col cols="6">
                        <div class="mt-8">
                          <v-textarea 
                           :disabled="!ALLOWED"
                          v-model="order.notes" rows="2"
                          label="Additional Notes"></v-textarea>
                        </div>
                        <div class="ma-1 mt-4" v-if="action=='modify'">
                                <widgets-purchase-logs :purchase="order" :show="activity"/>
                        </div>
                     
                      </v-col>
                      <v-col cols="6">
                        <table class="va-table va-table-border-bot">
                          <tr>
                            <td>SUB-TOTAL:</td>
                            <td class="text-right font-weight-bold text-h7">{{$money(SUBTOTAL)}}</td>
                          </tr>
                        
                          <tr v-for="(tax,t) in taxes" :key="t">
                            <td><v-icon v-if="ALLOWED"  left color="warning" small @click="removeTax(t)">mdi-close</v-icon> {{tax.name}}:</td>
                            <td class="text-right">{{$money(tax.amount)}}</td>
                          </tr>
                          <tr v-for="(dis,d) in discounts" :key="d+'-dis'">
                            <td class="bg-warning-light"><v-icon  v-if="ALLOWED"  left color="warning" small @click="removeDiscount(d)">mdi-close</v-icon> {{dis.name}}:</td>
                            <td class="bg-warning-light text-right">{{$money(dis.amount)}}</td>
                          </tr>
                          
                          <tr>
                            <td>TOTAL:</td>
                            <td class="text-right font-weight-bold text-h6">{{$money(TOTAL)}}</td>
                          </tr>
                       
                        </table>
                       <zera-custom-fields v-if="ALLOWED"  title="Taxes & Expenses" 
                       :params="[
                          {value: '', type:'text',label: 'Name'}, 
                          {value: '', type:'number',label: 'Amount'}
                        ]" 
                       icon="mdi-plus" @CFEvent="taxEv"/>

                        <zera-custom-fields v-if="ALLOWED"  title="Discounts" 
                       :params="[
                          {value: '', type:'text',label: 'Name'}, 
                          {value: '', type:'number',label: 'Amount'}
                        ]" 
                       icon="mdi-plus" @CFEvent="discountEv"/>
                                
                    
                          <div class="text-center mt-10">
                            <v-row no-gutters>
                              <v-flex v-for="(sign, index) in signatories" :key="index">
                                   <img v-if="sign.data != null" :src="sign.data" width="180px"/>
                                  <v-divider />
                                  <v-icon color="info" @click="sign_index= index,pad=true">mdi-draw-pen</v-icon><br/>
                                  <v-icon v-if="ALLOWED" left color="warning" small @click="removeSign(index)">mdi-close</v-icon>  {{sign.name}} <br/> <em>{{sign.position}}</em>
                              </v-flex>
                            </v-row>
                         
                        </div>
                          <div class="pa-3 text-center mt-4">
                            <zera-custom-fields v-if="ALLOWED"  title="Add Signatories" icon="mdi-draw-pen"
                            :params="[
                              {value: '', type:'text',label: 'Position'}, 
                              {value: '', type:'text',label: 'Name'}
                            ]" 
                            @CFEvent="signEv"/>
                          </div>
                          <v-divider class="mt-4 mb-4"/>
                          <v-bottom-navigation class="elevation-0">
                             <v-btn large  color="info" dark @click="order.status = 'Approved', log_message=message.approved, validate()" tile small v-if="order.status == 'Requested'">
                                <v-icon color="#fff">mdi-check</v-icon>
                                <span class="text-white">Approve</span>
                              </v-btn>
                              <v-btn large color="info" dark @click="order.status = 'Delivered', log_message=message.delivered, validate()" tile small v-if="order.status == 'Approved'">
                                <v-icon color="#fff">mdi-dolly</v-icon>
                                <span class="text-white">Delivered</span>
                              </v-btn>
                              <v-btn large color="warning" dark @click="order.status = 'Cancelled', log_message=message.cancel, validate()" tile small v-if="order.status != 'Cancelled'">
                                <v-icon color="#fff">mdi-cancel</v-icon>
                                <span class="text-white">Cancel</span>
                              </v-btn>
                          </v-bottom-navigation>
                      </v-col>
                  </v-row> 
                  <v-row>
                    <v-col cols="12" class="text-right">
                 
                     
                      
                     </v-col>
                   </v-row>   
                  
              </v-card-text>
              
          </v-card>

     
        </v-col>

    </v-row> 

    
  </v-card>
        <va-signature-pad :show="pad" @DialogEvent="padEvent" />
    <va-vendor-form :show="vendorForm" @DialogEvent="vEv"/>
    <va-inventory-short :show="showform" @DialogEvent="prEv"/>
  </v-dialog>
</template>

<script>

export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selectedID: {
       type: Number,
        default: null
    },
     data: {
       type: Object,
        default: ()=>{}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
    action: '',
    pad: false,
    sign_index:null,
      menu:false,
      activity: false,
      taxmenu: false,
      showform: false,
      date:'',
      purchase:{},
      po_items:[],
      vendorForm: false,
      po_date: '',
      order:{vendor:{}},
      terms:{payment_term:"",shipping_term:"", shipping_via:""},
      valid: true,
      latlong:{},
      vendors:[],
      productlist:[],
      product:{},
      taxes_item:{},
      taxes:[],
      signatories:[],
      discounts:[],
      log_message:"Purchase has been modified.",
      messages:{
        approved: "Purchase request has been approved!.",
        delivered: "Purchase has been delivered.",
        cancel: "Purchase has been cancelled.",
        signed: "Purchase request has been signed",
      }
  }),
  computed: {
      TOTAL(){
        return (this.SUBTOTAL + this.TOTALTAX) - this.TOTALDISCOUNTS
      },
      SUBTOTAL() {
        if(this.po_items == null) { return 0}
         var total = this.po_items.reduce((res,item)=>{
            res=res+this.$IsNum(item.amount)
            return res
         },0)
         return total
      },
      TOTALTAX() {
         if(this.taxes == null) { return 0}
         var total = this.taxes.reduce((res,item)=>{
            res=res+this.$IsNum(item.amount)
            return res
         },0)
         return total
      },
       TOTALDISCOUNTS() {
         if(this.discounts == null) { return 0}
         var total = this.discounts.reduce((res,item)=>{
            res=res+this.$IsNum(item.amount)
            return res
         },0)
         return total
      },
      PAYMENT_TERMS() {
       if(this.$store.state.sys_vars.length>0) {
        return this.GET_SYSVARS('payment_terms')
       } else {
        return []
       }
      },
       ALLOWED(){
       if(this.data.status == null || this.data.status == 'Requested') {
        return true
       }
        return false
       }
  },
  watch: {
    show (v) {
      if (v) {
        this.item = {}
        this.licenses = []
        this.getProductList()
        this.getVendors()
        this.action = this.state
         this.terms =   []
            this.po_items =  []
            this.taxes = []
            this.discounts =[]
            this.signatories =[]
        if(this.action == 'modify') {
            this.order = this.data
            this.terms =   this.order.terms 
            this.po_items =  this.order.items 
            this.taxes = this.order.taxes 
            this.discounts = this.order.discounts
            this.signatories =this.order.signatories
            setTimeout(()=>{this.activity = true}, 800)
           
        }
      }  else {
        this.order = {}
        this.product = {}
      }
    }
  },
  methods: {
    validate () {
        if (this.$refs.form.validate()) {
            this.state=='new'?this.Add():this.Update()
        }
      },
      PostLog(message){
            
            this.logs.push( {
                "user": this.$session.get('fullname'),
                "message": this.Strip(message),
                "timestamp": this.$moment().format("YYYY-MM-DD hh:mm A")
            })
           let params = {
            table: "purchases", 
            type:"update",
            query:`update purchases set  logs='${JSON.stringify(this.logs)}'::jsonb where id=${this.purchase.id}`
        }
   
        this.$http.post("new_data", params).then(response => {
          console.log(response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        this.message = ""
        }).catch(e => {
          console.log(e.data)
        })
    },
      padEvent(data){
        this.pad = false
        if(data != "close") {
          var sign = this.signatories[this.sign_index]
          sign.data = data
          this.signatories[this.sign_index] = sign
          this.log_message = this.messages.signed
          this.validate()
        }
        
        console.log(data)
      },
      signEv(item){
         if(this.signatories == null) {this.signatories = []}
        if(item[0].value && item[1].value) {
          this.signatories.push({position: item[0].value.trim(), name: item[1].value})
        }
      },
       discountEv(item){
        if(this.discounts == null) {this.discounts = []}
        if(item[0].value && item[1].value) {
          this.discounts.push({name: item[0].value.trim(), amount: item[1].value})
        }
      },
      taxEv(item){
        if(this.taxes == null) {this.taxes = []}
        if(item[0].value && item[1].value) {
          this.taxes.push({name: item[0].value.trim(), amount: item[1].value})
        }
      },
       removeSign(_index) {
          this.signatories.splice(_index,1)
      },
       removeDiscount(_index) {
          this.discounts.splice(_index,1)
      },
      removeTaxes(_index) {
          this.taxes.splice(_index,1)
      },
      prEv(){
        this.showform = false
        this.getProductList()
      },
      vEv(){
          this.vendorForm = false
          this.getVendors()
      },
      removeItem(_index){
        this.po_items.splice(_index,1)
      },
      removeTax(_index){
        this.taxes.splice(_index,1)
      },
      addItem(_product){
        if(_product) {
          if( this.po_items == null) {
            this.po_items = []
           } 
          let params = {
              id: _product.id,
              name: _product.name,
              description: _product.description,
              type: _product.type,
              quantity:0,
              unit_price: 0,
              amount:0
            }
           
           this.po_items.push(params)
        }
            
      },
      getVendors(){
        this.QUERY('sales','select * from vendors order by id desc', (res)=>{
              this.vendors = res.results
            })
      },
      getProductList(){
         this.QUERY('sales','select name, description from products order by id desc', (res)=>{
              this.productlist = res.results
            })
      },
      Update(){
         var log = {
          user:this.$session.get('fullname'),
          message: this.log_message,
          timestamp: this.$moment().format("YYYY-MM-DD hh:mm A") 
        }
        
        this.order.terms = this.terms
        this.order.created_by = this.$IsNum(this.$session.get('userID'))
         this.order.amount = this.$IsNum(this.TOTAL)
         this.order.items = this.po_items
         this.order.taxes = this.taxes
          this.order.discounts = this.discounts
          this.order.signatories = this.signatories
          if(this.order.logs == null) { this.order.logs = []} 
          this.order.logs.push(log)
            this.$http.post("update_purchase", this.order).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent()
          }
        }).catch(e => {
          this.disabled=false
          console.log(e.data)
        })
      },
      Add(){
         var log = {
          user:this.$session.get('fullname'),
          message: "Posted a new purchase request",
          timestamp: this.$moment().format("YYYY-MM-DD hh:mm A") 
        }
        this.order.company = {
          name: this.GET_SYSVARS('company_name'),
          address: this.GET_SYSVARS('company_address'),
          mobile: this.GET_SYSVARS('company_mobile'),
          telephone: this.GET_SYSVARS('company_tel'),
          email: this.GET_SYSVARS('company_email'),  
        }
        this.order.terms = this.terms
        this.order.created_by = this.$IsNum(this.$session.get('userID'))
         this.order.amount = this.$IsNum(this.TOTAL)
         this.order.status = "Requested"
         this.order.items = this.po_items
         this.order.taxes = this.taxes
          this.order.discounts = this.discounts
          this.order.signatories = this.signatories
          this.order.logs = [log]

          console.log(this.order)
            this.$http.post("new_purchase", this.order).then(response => {
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
          if(response.data.status){
              this.emitToParent()
          }
        }).catch(e => {
          this.disabled=false
          console.log(e.data)
        })
      },
    
    emitToParent () {
        this.$emit('DialogEvent', "")
    }
  }
}
</script>
